import { render, staticRenderFns } from "./WelcomeV2.vue?vue&type=template&id=b10fb95c&scoped=true&"
import script from "./WelcomeV2.vue?vue&type=script&lang=js&"
export * from "./WelcomeV2.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeV2.vue?vue&type=style&index=0&id=b10fb95c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10fb95c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBtn,VChip,VContainer,VIcon,VImg})
